function fixTolstoyDuplicateIds() {
  // Fix duplicate filter IDs
  document.querySelectorAll('filter[id="filter0_bd_29326_18227"]').forEach(function(filter, index) {
    if (index > 0) {
      const newId = `filter0_bd_29326_18227_${index}`;
      const filterId = filter.getAttribute('id');
      
      // Update the filter ID
      filter.setAttribute('id', newId);
      
      // Find and update any elements that reference this filter
      const parentSvg = filter.closest('svg');
      if (parentSvg) {
        const elementsUsingFilter = parentSvg.querySelectorAll(`[filter="url(#${filterId})"]`);
        elementsUsingFilter.forEach(function(element) {
          element.setAttribute('filter', `url(#${newId})`);
        });
      }
    }
  });

  // Fix duplicate clipPath IDs
  document.querySelectorAll('clipPath[id="pauseIcon"]').forEach(function(clipPath, index) {
    if (index > 0) {
      const newId = `pauseIcon_${index}`;
      const clipPathId = clipPath.getAttribute('id');
      
      // Update the clipPath ID
      clipPath.setAttribute('id', newId);
      
      // Find and update any elements that reference this clipPath
      const parentSvg = clipPath.closest('svg');
      if (parentSvg) {
        const elementsUsingClipPath = parentSvg.querySelectorAll(`[clip-path="url(#${clipPathId})"]`);
        elementsUsingClipPath.forEach(function(element) {
          element.setAttribute('clip-path', `url(#${newId})`);
        });
      }
    }
  });
}

// Run the fix when the DOM is loaded
document.addEventListener('DOMContentLoaded', fixTolstoyDuplicateIds);

// Also run when page:loaded event is triggered (Shopify-specific)
document.addEventListener('page:loaded', fixTolstoyDuplicateIds);

// Use MutationObserver to detect when Tolstoy elements are added to the DOM
const tolstoyIdObserver = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.addedNodes.length) {
      setTimeout(fixTolstoyDuplicateIds, 500); // Small delay to ensure elements are fully rendered
    }
  }
});

// Start observing the document body for added nodes
tolstoyIdObserver.observe(document.body, { childList: true, subtree: true });

// Poll a few times to catch any elements that might be added dynamically
let idPollCount = 0;
const idPollInterval = setInterval(() => {
  fixTolstoyDuplicateIds();
  idPollCount++;
  if (idPollCount > 10) clearInterval(idPollInterval);
}, 1000);
